import { useRef } from "react";
import { Helmet } from "react-helmet";
import "./styled.scss";
import "../../../home.scss";
import { Link } from "react-router-dom";

const TermsHeader = () => {
  return (
    <div className="section terms_head" style={{}}>
      <div className="content_container">
        <div
          className="content terms_head"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="terms_head_left">
            <h1>Terms of service</h1>
            <h2>Last Updated: March 21, 2025</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

const TermsContent = () => {
  return (
    <div className="section terms" style={{}}>
      <div className="content_container" style={{}}>
        <div className="content terms">
          <div className="terms_body">
            <div className="terms_sec">
              <div className="content">
                <p>
                  Welcome, and thank you for your interest in Brandclub, LLC (“
                  <strong>Brandclub</strong>,” “<strong>we</strong>,” or “
                  <strong>us</strong>”) and our website at
                  https://brandclub.com/, along with our related websites,
                  networks, mobile and other applications, and other services
                  provided by us (collectively, the “<strong>Service</strong>”).
                  These Terms of Service are a legally binding contract between
                  you and Brandclub regarding your use of the Service.
                  <br />
                  <br />
                  PLEASE READ THE FOLLOWING TERMS CAREFULLY.
                  <br />
                  <br />
                  <strong>
                    BY CLICKING “ACCEPT,” DOWNLOADING, INSTALLING, MAKING A
                    PURCHASE, OR OTHERWISE ACCESSING OR USING THE SERVICE, YOU
                    AGREE THAT YOU HAVE READ AND UNDERSTOOD, AND, AS A CONDITION
                    TO YOUR USE OF THE SERVICE, YOU AGREE TO BE BOUND BY, THE
                    FOLLOWING TERMS AND CONDITIONS, INCLUDING BRANDCLUB’S
                    PRIVACY POLICY{""}
                  </strong>
                  (TOGETHER, THESE “<strong>TERMS</strong>”). If you are not
                  eligible, or do not agree to the Terms, then you do not have
                  our permission to use the Service. TERMS.
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="title">
                <div className="text">Arbitration notice</div>
              </div>
              <div className="content">
                <p>
                  Except for certain kinds of disputes described in Section 17,
                  you agree that disputes arising under these Terms will be
                  resolved by binding, individual arbitration, and BY ACCEPTING
                  THESE TERMS, YOU AND BRANDCLUB ARE EACH WAIVING THE RIGHT TO A
                  TRIAL BY JURY OR TO PARTICIPATE IN ANY CLASS ACTION OR
                  REPRESENTATIVE PROCEEDING. YOU AGREE TO GIVE UP YOUR RIGHT TO
                  GO TO COURT to assert or defend your rights under this
                  contract (except for matters that may be taken to small claims
                  court). Your rights will be determined by a NEUTRAL ARBITRATOR
                  and NOT a judge or jury. (See Section 17.)
                </p>
              </div>
            </div>
            <div className="terms_sec">
              <div className="content">
                <ol>
                  {/* 1 */}
                  <li>
                    <p>
                      <strong>Brandclub Overview</strong>. Our Service connects
                      shoppers (each a “<strong>User</strong>” or “
                      <strong>you</strong>”), participating consumer product
                      brands (each a “<strong>Brand</strong>”), and approved
                      third-party retailers (each an “
                      <strong>Approved Retailer</strong>”) to enhance the retail
                      experience. Users may be able to purchase Brand products
                      directly from Approved Retailers through our Service and
                      earn cash back for making a purchase, engaging with a
                      Brand’s products, or for promoting a Brand’s products to
                      third parties through social media, email, text, and other
                      communication methods (collectively, “
                      <strong>Rewards</strong>”).
                    </p>
                  </li>
                  {/* 2 */}
                  <li>
                    <p>
                      <strong>Eligibility</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          You represent and warrant that: (a) you are at least
                          18 years old or the age of majority in your country of
                          residence; (b) you have not previously been suspended
                          or removed from the Service; and (c) your use of the
                          Service complies with any and all applicable laws and
                          regulations. If you are a parent or guardian who
                          allows your child under 18 to use our Service, you
                          provide all consent necessary for your child's use of
                          our Service and agree to be legally responsible for
                          all activity of your child on your account.
                        </p>
                      </li>
                      <li>
                        <p>
                          If you are an entity, organization, or company, the
                          individual accepting these Terms on your behalf
                          represents and warrants that they have authority to
                          bind you to these Terms and you agree to be bound by
                          these Terms.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 3 */}
                  <li>
                    <p>
                      <strong>
                        Your relationship with Us and Approved Retailers.
                      </strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          <strong>Accounts and Registration</strong>. To access
                          portions of our Service, you will need to register a
                          Brandclub account. You may register with your Google,
                          Facebook, or Apple account or create a new account
                          with Brandclub on the Service. When you make an
                          account with Brandclub, you may be required to provide
                          us with your name, email address, phone number, age,
                          and gender. You agree that the information you provide
                          to us is accurate, complete, and not misleading, and
                          that you will keep it accurate and up to date at all
                          times. When you register, you will be asked to create
                          a password. You are solely responsible for maintaining
                          the confidentiality of your account and password, and
                          you accept responsibility for all activities that
                          occur under your account. If you believe that your
                          account is no longer secure, then you should
                          immediately notify us at{" "}
                          <a href={"mailto:support@brandclub.com"}>
                            support@brandclub.com
                          </a>
                          . When a User has registered with the Service, the
                          User will be able to join a Brand’s club. If a User
                          joins a Brand’s club, you may be eligible for Rewards
                          from that Brand within our Service.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Approved Retailer Accounts</strong>. When you
                          use our Service, you will be asked to share Approved
                          Retailer account credentials. By providing Approved
                          Retailer account credentials to Brandclub, you agree
                          that Brandclub may act as your agent to: (a) complete
                          User-directed transactions, (b) review and collect (“
                          <strong>Sync</strong>”) any information within your
                          account (your “
                          <strong>Approved Retailer Account</strong>”),
                          including current, historical, and future transaction
                          information, and (c) create Brandclub account on your
                          behalf if one does not already exist. You also agree
                          that Brandclub may share this information with third
                          parties as set forth in our{" "}
                          <Link to={"/privacy"}>Privacy Policy</Link>. You
                          represent and agree that you are an authorized user of
                          the Approved Retailer Account, and that you have the
                          authority to provide Brandclub with access to that
                          account as your agent. You acknowledge and agree that
                          you cannot redeem Rewards that are promoted on the
                          Service without sharing your Approved Retailer
                          Account.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Payment Processing</strong>. When you use our
                          Service, we will complete your transaction using the
                          default payment method you have on file with an
                          Approved Retailer. If your transaction is
                          unsuccessful, you authorize Brandclub to complete your
                          transaction using any valid payment card provided
                          directly to Brandclub. YOU REPRESENT AND WARRANT THAT
                          YOU HAVE THE LEGAL RIGHT TO USE ANY PAYMENT CARDS OR
                          OTHER PAYMENT METHODS UTILIZED IN CONNECTION WITH ANY
                          TRANSACTION. By submitting such information, you grant
                          us the right to provide such information to third
                          parties for purposes of facilitating the transactions
                          initiated by you or on your behalf. You agree to pay
                          all charges that may be incurred by you or on your
                          behalf through the Services, at the prices in effect
                          when such charges are incurred including, without
                          limitation, all shipping and handling charges, and you
                          authorize us to charge all sums for the transactions
                          that you make with the payment method specified at the
                          time. In addition, you remain responsible for any
                          taxes that may be applicable to your transactions. You
                          authorize us to charge all applicable amounts for the
                          orders that you make to the payment method specified
                          at the time of purchase.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 4 */}
                  <li>
                    <p>
                      <strong>Rewards</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          <strong>Rewards Terms and Conditions</strong>. All
                          Rewards shall be governed by our{" "}
                          <Link to={"/rewardterms"}>
                            Rewards Terms and Conditions
                          </Link>
                          , which are incorporated into these Terms by
                          reference.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Reward Tasks</strong>. You may be eligible for
                          certain Rewards from your use of the Service and your
                          purchasing activity. For example, you may be able to
                          earn Rewards if you complete one of the following (in
                          accordance with the specific instructions provided by
                          the Service): (a) join a Brand’s club; (b) purchase a
                          Brand’s products from an Approved Retailer; (c)
                          recommend a Brand’s product on one of your Social
                          Media Accounts (defined below), by email, or text
                          message; or (d) take a survey that is posted on the
                          Service by a Brand (each a “Reward Task”). Brandclub
                          may require you to Sync your Approved Retailer Account
                          after you complete a Reward Task to verify that you
                          have completed the Reward Task. Brandclub does not
                          guarantee that any particular Reward will be available
                          on any given product for any specific User at any
                          moment in time. The Reward amount you may be able to
                          earn may vary by Brand and by product. Furthermore,
                          not all Rewards may be available to Users at all
                          times, and different Rewards may be available only to
                          certain Users. Items for which Rewards are or will be
                          available are subject to change at any time, for any
                          reason, and at the sole discretion of Brandclub and
                          participating Brands. Brandclub reserves the right to
                          change, remove, discontinue, or otherwise alter the
                          available Rewards or Commissions at any time. For more
                          information on how to earn Rewards, please review our
                          Reward{" "}
                          <Link to={"/rewardterms"}>
                            Rewards Terms and Conditions
                          </Link>
                          .
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Endorsements</strong>. Posting links on your
                          Social Media Accounts or sending links by email or
                          text message that allow your friends to purchase a
                          Brand’s product, or taking other actions approved by
                          Brandclub on your Social Media Accounts (each action
                          an “Endorsement”). If you choose to make an
                          Endorsement to earn Rewards, you must: (a) clearly and
                          conspicuously include a statement in your Endorsement
                          disclosing that the Brand is compensating you for your
                          Endorsement; (b) not include third party intellectual
                          property (for example, photos, text, other
                          copyright-protected work, or trademarks) in your
                          Endorsement without obtaining all necessary rights and
                          authorizations from the third party rightsholder; (c)
                          only make truthful and not misleading statements about
                          the Brand and its products; and (d) abide by the terms
                          of our “
                          <Link to={"/endorsement"}>Endorsement Policy</Link>”,
                          the rules and policies of the applicable social media
                          platform or Approved Retailer, and any other rules or
                          policies that may be provided by the Brand. If you
                          review a Brand’s product for a Reward, you are under
                          no obligation to provide a positive review of the
                          product. You agree that Brandclub and Brands may
                          monitor your Endorsements for compliance with this
                          Section 4.2. If you fail or if we reasonably believe
                          that you have failed to comply with this Section or
                          any other portion of the Terms, Brandclub has the
                          right to: (i) withhold your Rewards; (ii) terminate or
                          suspend your account; (iii) require you to remove your
                          Endorsement; or (iv) pursue any other legal remedy
                          available to Brandclub. If you would like more
                          information about the rules and regulations concerning
                          user Endorsements please see:
                          <p style={{ wordBreak: "break-all" }}>
                            https://www.ftc.gov/sites/default/files/attachments/press-releases/ftc-publishes-final-guides-governing-endorsements-testimonials/091005revisedendorsementguides.pdf
                          </p>
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Redeeming Rewards</strong>. Rewards may not be
                          immediately unlocked. When you complete a Brand’s
                          Reward Task, your Reward is locked in your Brandclub
                          account (“Locked Reward”). Your Locked Reward does not
                          become unlocked for cash until you complete another
                          Reward Task from that Brand (“Unlocked Reward”). To
                          verify whether you have completed a Reward Task,
                          Brandclub may require you to Sync your Approved
                          Retailer Account information after each Reward Task
                          you complete. Locked Rewards will expire if they are
                          not converted into Unlocked Rewards within 30-60 days.
                          Locked Rewards may expire at different times, and it
                          is your responsibility to monitor your Locked Rewards
                          and keep track of when they expire. Unlocked Rewards
                          do not automatically redeem into cash; you must choose
                          to redeem an eligible Unlocked Reward to your Venmo or
                          PayPal account. Unlocked Rewards may expire if they
                          are not redeemed for cash within 180 days. A Brand may
                          allow you to earn a Reward by promoting the Brand’s
                          products on your social media accounts, including your
                          Facebook, TikTok, Instagram, or Snapchat accounts
                          (each a “<strong>Social Media Account</strong>”), by
                          email, or text message. A Brand may require you to
                          post specific text, including a link to purchase one
                          of the Brand’s products on your Social Media Account
                          or in your email and text messages. You may be able to
                          earn a Reward if any of your friends or social
                          connections use your link to download one of our
                          applications, register a Brandclub account, or
                          purchase the product. All Rewards earned through a
                          referral will be converted to an Unlocked Reward after
                          Brandclub completes any necessary fraud checks, as
                          long as the Brand providing the Reward has sufficient
                          funds in its Rewards account.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 5 */}
                  <li>
                    <p>
                      <strong>License and Restrictions</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          <strong>Limited License Grant to You</strong>. Subject
                          to your complete and ongoing compliance with these
                          Terms, Brandclub grants you, solely for your personal,
                          non-commercial use, a limited, non-exclusive,
                          non-transferable, non-sublicensable, revocable license
                          to: (a) install and use one object code copy of any
                          mobile application associated with the Service
                          obtained from a legitimate marketplace (whether
                          installed by you or pre-installed on your mobile
                          device by the device manufacturer or a wireless
                          telephone provider) on a mobile device that you own or
                          control; and (b) access and use the Service.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>License Restriction</strong>. Except and
                          solely to the extent such a restriction is
                          impermissible under applicable law, you may not, and
                          may not attempt to: (a) reproduce, distribute,
                          publicly display, publicly perform, or create
                          derivative works of the Service; (b) make
                          modifications to the Service; (c) interfere with or
                          circumvent any feature of the Service, including any
                          security or access control mechanism; (d) decompile,
                          disassemble, reverse engineer, reverse assemble,
                          analyze or otherwise examine, or attempt to derive the
                          source code of the Service; (e) sell, resell, license,
                          rent, lease, timeshare, or act as a service bureau or
                          provide subscription services for the Service or any
                          part thereof (including any search results obtained
                          through use of the Service); or (f) make any other use
                          of the Service, Materials (defined below), or any
                          other content provided by Brandclub or its users on or
                          through the Service, including any data concerning
                          other users of the Service, except as expressly
                          authorized by Brandclub in these Terms. If you are
                          prohibited under applicable law from using the
                          Service, you may not use it.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Feedback</strong>. We respect and appreciate
                          the thoughts and comments from our users. If you
                          choose to provide input and suggestions regarding
                          existing functionalities, problems with or proposed
                          modifications or improvements to the Service
                          (“Feedback”), then you hereby grant Brandclub an
                          unrestricted, perpetual, irrevocable, non-exclusive,
                          fully-paid, royalty-free right to exploit the Feedback
                          in any manner and for any purpose, including to
                          improve the Service and create other products and
                          services. We will have no obligation to prove you with
                          attribution for any Feedback you provide to us.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 6 */}
                  <li>
                    <p>
                      <strong>Ownership; Proprietary Rights</strong>. The
                      Service is owned and operated by Brandclub. The visual
                      interfaces, graphics, design, compilation, information,
                      data, computer code (including source code or object
                      code), products, software, services, and all other
                      elements of the Service provided by Brandclub (“
                      <strong>Materials</strong>”) are protected by intellectual
                      property and other laws. All Materials included in the
                      Service are the property of Brandclub or its third-party
                      licensors. Except as expressly authorized by Brandclub,
                      you may not make use of the Materials. There are no
                      implied licenses in these Terms and Brandclub reserves all
                      rights to the Materials not granted expressly in these
                      Terms.
                    </p>
                  </li>
                  {/* 7 */}
                  <li>
                    <p>
                      <strong>Third-party terms</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          <strong>Brands</strong>. Brandclub enables you to
                          engage with Brands and Approved Retailers. By using
                          our Service, you are directing Brandclub to share the
                          Approved Retailer Account information you provide to
                          us, excluding your login credentials, with all our
                          participating Brands regardless of your actual
                          interaction with each Brand. Brands will engage with
                          you according to their respective privacy policies and
                          you acknowledge and agree that Brandclub is not
                          responsible for and does not control such policies. If
                          you terminate your Brandclub account, Brands will
                          continue to have access to your Approved Retailer
                          Account information already in such Brand’s possession
                          and may continue to contact you. If you want more
                          information about the types of information that
                          Brandclub shares with Brands, please review our
                          Privacy Policy.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Approved Retailers</strong>. Brandclub may
                          allow you to connect your Approved Retailer Account
                          with the Service. To do so, you must provide the login
                          credentials for your Approved Retailer Account. You
                          authorize Brandclub to act as your agent and log into
                          your Approved Retailer Account on your behalf and to
                          facilitate any User-directed transaction through the
                          Service. Any information processed from your Approved
                          Retailer Account will be used and handled consistent
                          with Brandclub’s Privacy Policy. You may also be
                          directed to an Approved Retailer’s website if you
                          choose to purchase or review a product that is
                          promoted on the Service. Your use of an Approved
                          Retailer’s website is governed by the terms and
                          conditions of the applicable Approved Retailer’s terms
                          and conditions. Brandclub has no control over, and is
                          not liable for any harm or damage resulting from: (a)
                          the processing of payments by an Approved Retailer;
                          (b) the pricing, product descriptions, quality,
                          condition, or shipping and handling of products
                          purchased from an Approved Retailer’s website; or (c)
                          any mistakes, errors, omissions, or inaccuracies in
                          any of the information provided on an Approved
                          Retailer’s website.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>
                            Third-Party Services and Linked Websites.
                          </strong>{" "}
                          Brandclub may provide tools through the Service that
                          allow you to export information, including User
                          Content, from the Service to third-party services,
                          including through features that allow you to link your
                          account on the Service with your Social Media Account
                          or through our implementation of third-party buttons
                          (such as “like” or “share” buttons). By using one of
                          these tools, you hereby authorize Brandclub to
                          transfer that information to the applicable
                          third-party service. Third-party services are not
                          under Brandclub’s control, and, to the fullest extent
                          permitted by law, Brandclub is not responsible for any
                          third-party service’s use of your exported
                          information. The Service may also contain links to
                          third-party websites. Linked websites are not under
                          Brandclub’s control, and Brandclub is not responsible
                          for their content. Please be sure to review the terms
                          of use and privacy policy of any third-party services
                          before you share any User Content or information with
                          such third-party services. Once sharing occurs,
                          Brandclub will have no control over the information
                          that has been shared.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Third-Party Software</strong>. The Service may
                          include or incorporate third-party software components
                          that are generally available free of charge under
                          licenses granting recipients broad rights to copy,
                          modify, and distribute those components (“Third-Party
                          Components”). Although the Service is provided to you
                          subject to these Terms, nothing in these Terms
                          prevents, restricts, or is intended to prevent or
                          restrict you from obtaining Third-Party Components
                          under the applicable third-party licenses or to limit
                          your use of Third-Party Components under those
                          third-party licenses, subject to the licenses granted
                          in these Terms.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 8 */}
                  <li>
                    <p>
                      <strong>User Content</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          <strong>User Content Generally</strong>. Certain
                          features of the Service may permit users to submit,
                          Sync their Social Media Accounts, upload, publish,
                          broadcast, or otherwise transmit (“
                          <strong>Post</strong>”) content to the Service,
                          including messages, Endorsements, reviews, photos,
                          video, or audio (including sound or voice recordings
                          and musical recordings embodied in the video or
                          audio), images, folders, data, text, and any other
                          works of authorship or other works (“
                          <strong>User Content</strong>”). You retain any
                          copyright and other proprietary rights that you may
                          hold in the User Content that you Post to the Service,
                          subject to the licenses granted in these Terms.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Limited License Grant to Brandclub</strong>.
                          By Posting User Content to or via the Service, you
                          grant Brandclub a worldwide, non-exclusive,
                          irrevocable, royalty-free, fully paid right and
                          license (with the right to sublicense through multiple
                          tiers) to host, store, transfer, display, publicly
                          perform (including by means of a digital audio
                          transmission), communicate to the public, reproduce,
                          modify for the purpose of formatting for display,
                          create derivative works as authorized in these Terms,
                          and distribute your User Content, in whole or in part,
                          in any media formats and through any media channels,
                          in each instance whether now known or hereafter
                          developed. All of the rights you grant in these Terms
                          are provided on a through-to-the-audience basis,
                          meaning the owners or operators of external services
                          will not have any separate liability to you or any
                          other third party for User Content Posted or otherwise
                          used on external services via the Service. You agree
                          to pay all monies owing to any person or entity
                          resulting from Posting your User Content and from
                          Brandclub’s exercise of the license set forth in this
                          Section.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Specific Rules for User Reviews</strong>. If
                          you Post User Content regarding a Brand’s products,
                          you agree that: (i) such User Content will be accurate
                          and reflect your genuinely held views about a product;
                          (ii) you will not post anything false, inaccurate,
                          misleading, deceptive, offensive, illegal, or
                          defamatory; (iii) you will only post User Content for
                          products you have actually purchased, and (iv) your
                          User Content will not solicit shill review, trade
                          review, or otherwise do anything to undermine the
                          integrity of our Service.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>
                            Specific Rules for Photographs and Images
                          </strong>
                          . If you Post a photograph or image to the Service
                          that includes one or more persons, you hereby grant
                          such persons and their administrators, guardians,
                          heirs, and trustees, if any, an irrevocable,
                          perpetual, royalty free, fully paid-up, worldwide
                          license to reproduce, distribute, and publicly display
                          that photograph for personal use and through any
                          online platform or service, including the Service,
                          Facebook, Instagram, and Twitter, but not to promote
                          any third-party product, good, or service. The license
                          contained in this Section does not permit the subject
                          of any photo or their administrators, guardians,
                          heirs, or trustees to sell that image or photograph,
                          whether on a standalone basis or as embodied in any
                          product.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>
                            Specific Rules for Musical Works and for Recording
                            Artists
                          </strong>
                          . If you are a composer or author of a musical work
                          and have granted non-exclusive rights to a Performing
                          Rights Organization (“PRO”), then you must notify your
                          PRO of the royalty-free license you grant through
                          these Terms to Brandclub. You are solely responsible
                          for ensuring your compliance with the relevant PRO’s
                          reporting obligations. If you have assigned your
                          rights to a music publisher or PRO, then you must
                          obtain the consent of that music publisher or PRO to
                          grant the royalty-free license(s) set forth in these
                          Terms or have that music publisher or PRO enter into
                          these Terms with Brandclub. Just because you authored
                          a musical work (e.g., wrote a song) does not mean you
                          have the right to grant Brandclub the licenses in
                          these Terms. If you are a recording artist under
                          contract with a record label, then you are solely
                          responsible for ensuring that your use of the Service
                          is in compliance with any contractual obligations you
                          have to your record label, including if you create any
                          new recordings through the Service that may be claimed
                          by your label. Finally, if you wish to perform a cover
                          song and Post it to the Service, you are responsible
                          for securing all rights in and to the underlying
                          musical work before Posting your recording or
                          performance of that musical work to the Service.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>
                            You Must Have Rights to the Content You Post; User
                            Content Representations and Warranties
                          </strong>
                          . You must own, or have the necessary license(s) to,
                          all of the proprietary rights in the User Content that
                          you Post. Brandclub disclaims all liability in
                          connection with User Content. You are solely
                          responsible for your User Content and the consequences
                          of providing User Content via the Service. By
                          providing User Content via the Service, you affirm,
                          represent, and warrant to us that:
                          <ol>
                            <li>
                              <p>
                                you are the creator and owner of the User
                                Content, or have the necessary licenses, rights,
                                consents, and permissions to authorize Brandclub
                                and users of the Service to use and distribute
                                your User Content as necessary to exercise the
                                licenses granted by you in this Section, in the
                                manner contemplated by Brandclub, the Service,
                                and these Terms;
                              </p>
                            </li>
                            <li>
                              <p>
                                your User Content, and the Posting or other use
                                of your User Content as contemplated by these
                                Terms, does not and will not: (i) infringe,
                                violate, misappropriate, or otherwise breach any
                                third-party right, including any copyright,
                                trademark, patent, trade secret, moral right,
                                privacy right, right of publicity, or any other
                                intellectual property, contract, or proprietary
                                right; (ii) slander, defame, libel, or invade
                                the right of privacy, publicity or other
                                property rights of any other person; or (iii)
                                cause Brandclub to violate any law or regulation
                                or require us to obtain any further licenses
                                from or pay any royalties, fees, compensation or
                                other amounts or provide any attribution to any
                                third parties; and
                              </p>
                            </li>
                            <li>
                              <p>
                                your User Content could not be deemed by a
                                reasonable person to be objectionable, profane,
                                indecent, pornographic, harassing, threatening,
                                embarrassing, hateful, or otherwise
                                inappropriate.
                              </p>
                            </li>
                          </ol>
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>User Content Removal and Disclaimer</strong>.
                          We are under no obligation to edit or control User
                          Content that you, other Users, or Brands Post and will
                          not be in any way responsible or liable for User
                          Content. Brandclub may, however, at any time and
                          without prior notice, screen, remove, edit, or block
                          any User Content that in our sole judgment violates
                          these Terms, is alleged to violate the rights of third
                          parties, jeopardizes the integrity of our Service, or
                          is otherwise objectionable. You understand that when
                          using the Service, you will be exposed to User Content
                          from a variety of sources and acknowledge that User
                          Content may be inaccurate, offensive, indecent, or
                          objectionable. You agree to waive, and do waive, any
                          legal or equitable right or remedy you have or may
                          have against Brandclub with respect to User Content.
                          If notified by a user or content owner that User
                          Content allegedly does not conform to these Terms, we
                          may investigate the allegation and determine in our
                          sole discretion whether to remove the User Content,
                          which we reserve the right to do at any time and
                          without notice. For clarity, Brandclub does not permit
                          infringing activities on the Service.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Monitoring Content</strong>. Brandclub does
                          not control and does not have any obligation to
                          monitor: (a) User Content; (b) any content made
                          available by third parties or Brands; or (c) the use
                          of the Service by its users or Brands. You acknowledge
                          and agree that Brandclub reserves the right to, and
                          may from time to time, monitor any and all information
                          transmitted or received through the Service for
                          operational and other purposes. If at any time
                          Brandclub chooses to monitor the content, then
                          Brandclub still assumes no responsibility or liability
                          for content, or any loss or damage incurred as a
                          result of the use of content. During monitoring,
                          information may be examined, recorded, copied, and
                          used in accordance with our Privacy Policy (defined
                          below). Brandclub may block, filter, mute, remove or
                          disable access to any User Content uploaded to or
                          transmitted through the Service without any liability
                          to the user who Posted such User Content to the
                          Service or to any other users of the Service.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 9 */}
                  <li>
                    <p>
                      <strong>Communications</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          <strong>Brand Messages</strong>. The Service may allow
                          Brands to send you messages or other communications
                          via the Service, and you may also use the Service to
                          send messages or other communications to Brands
                          (collectively “<strong>Brand Messages</strong>”).
                          Brandclub may terminate the ability of any User to
                          send or receive Brand Messages at any time and for any
                          reason, without any liability to that User. If a Brand
                          sends you an objectionable Brand Message, then please
                          notify us by sending an email to
                          <a href={"mailto:support@brandclub.com"}>
                            support@brandclub.com
                          </a>
                          . You agree that Brandclub may monitor Brand Messages
                          for compliance with these Terms, and therefore, Brand
                          Messages should not be considered confidential or
                          proprietary. You hereby grant us an assignable,
                          sublicensable, irrevocable license to reproduce and
                          transmit your Brand Messages in connection with
                          facilitating transmission to the intended recipient
                          through the Service and for such other purposes as
                          Brandclub may deem appropriate at its sole discretion.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Text Messaging</strong>. You agree that
                          Brandclub may send you text messages pursuant to our{" "}
                          <Link to={"/smsterms"}>SMS Terms of Service</Link>,
                          which are incorporated by this reference.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Push Notifications</strong>. When you install
                          our app on your mobile device, you will be asked to
                          accept or deny push notifications, which are messages
                          an app sends you on your mobile device when the app is
                          not on. You can turn off notifications by visiting
                          your mobile device’s “settings” page.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Email</strong>. Brands and Brandclub may send
                          you emails concerning products and services or
                          available Rewards. Brandclub may send you operational
                          emails, including registration messages, which are
                          essential to the Service. If you do not wish to
                          receive operational emails from us, do not use the
                          Service. You may opt out of promotional emails by
                          following the unsubscribe instructions in the
                          promotional email.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 10 */}
                  <li>
                    <p>
                      <strong>Prohibited Conduct</strong>
                    </p>
                    <ol>
                      <li>
                        <p>BY USING THE SERVICE, YOU AGREE NOT TO:</p>
                        <ol>
                          <li>
                            <p>
                              use the Service for any illegal purpose or in
                              violation of any local, state, national, or
                              international law;
                            </p>
                          </li>
                          <li>
                            <p>
                              harass, threaten, demean, embarrass, or otherwise
                              harm any other User or a representative of a Brand
                              on the Service;
                            </p>
                          </li>
                          <li>
                            <p>
                              infringe, violate, encourage others to violate, or
                              provide instructions on how to violate, the rights
                              of any other party or breach any contract or legal
                              duty to any other parties, including by infringing
                              or misappropriating any third-party intellectual
                              property right;
                            </p>
                          </li>
                          <li>
                            <p>
                              interfere with security-related features of the
                              Service, including by: (a) disabling or
                              circumventing features that prevent or limit use,
                              printing or copying of any content; or (b) reverse
                              engineering or otherwise attempting to discover
                              the source code of any portion of the Service
                              except to the extent that the activity is
                              expressly permitted by applicable law;
                            </p>
                          </li>
                          <li>
                            <p>
                              interfere with the operation of the Service or any
                              user’s enjoyment of the Service, including by: (a)
                              uploading or otherwise disseminating any virus,
                              adware, spyware, worm, or other malicious code;
                              (b) making any unsolicited offer or advertisement
                              to another user of the Service; (c) collecting
                              personal information about another user or third
                              party without consent; or (d) interfering with or
                              disrupting any network, equipment, or server
                              connected to or used to provide the Service;
                            </p>
                          </li>
                          <li>
                            <p>
                              attempt to access or search the Service or content
                              available on the Service or download content from
                              the Service through the use of any engine,
                              software, tool, agent, device or mechanism
                              (including spiders, robots, crawlers, data mining
                              tools and the like) other than the software and/or
                              search agents provided by Brandclub or other
                              generally available third-party web browsers;
                            </p>
                          </li>
                          <li>
                            <p>
                              perform any fraudulent activity, including but not
                              limited to: (a) buying products and returning
                              them; (b) linking your Brandclub account with an
                              Approved Retailer Account that does not belong to
                              you; (c) creating fake Approved Retailer Accounts
                              or Social Media Accounts; (d) impersonating any
                              person or entity; (e) claiming a false affiliation
                              or identity; (f) access any other Service account
                              without permission; or (g) or falsifying your age
                              or date of birth;
                            </p>
                          </li>
                          <li>
                            <p>
                              sell or otherwise transfer the access granted
                              under these Terms or any Materials (as defined in
                              Section 6) or any right or ability to view,
                              access, or use any Materials; or
                            </p>
                          </li>
                          <li>
                            <p>
                              attempt to do any of the acts described in this
                              Section 10 or assist or permit any person in
                              engaging in any of the acts described in this
                              Section 10.
                            </p>
                          </li>
                        </ol>
                      </li>
                      <li>
                        <p>
                          If Brandclub, in its sole discretion, determines that
                          you have been engaged in any activity that it deems to
                          be fraudulent or in violation of these Terms,
                          including the Brandclub Rewards Terms and Conditions,
                          or the Endorsement Policy. Brandclub may suspend or
                          terminate your account, revoke any Locked Rewards, or
                          take any legal action available to it.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 11 */}
                  <li>
                    <p>
                      <strong>Intellectual Property Rights</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          <strong>Respect of Third-Party Rights</strong>.
                          Brandclub respects the intellectual property rights of
                          others, takes the protection of intellectual property
                          rights very seriously, and asks users of the Service
                          to do the same. Infringing activity will not be
                          tolerated on or through the Service.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>DMCA Notification</strong>. We comply with the
                          provisions of the Digital Millennium Copyright Act
                          applicable to Internet service providers (17 U.S.C.
                          §512, as amended). If you have an intellectual
                          property rights-related complaint about any material
                          on the Service, you may contact our Designated Agent
                          at the following address:
                          <br />
                          Brand Club, LLC
                          <br />
                          ATTN: Legal Department (Copyright Notification)
                          <br />
                          801 5th Ave, Suite 2800, Seattle, WA 98104
                          <br />
                          614-832-5902
                          <br />
                          Email: copyright@brandclub.com
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>
                            Procedure for Reporting Claimed Infringement
                          </strong>
                          . If you believe that any content made available on or
                          through the Service has been used or exploited in a
                          manner that infringes an intellectual property right
                          you own or control, then please promptly send a
                          “Notification of Claimed Infringement” to the
                          Designated Agent identified above containing the
                          following information:
                        </p>
                        <ol>
                          <li>
                            <p>
                              an electronic or physical signature of the person
                              authorized to act on behalf of the owner of the
                              copyright or other right being infringed;
                            </p>
                          </li>
                          <li>
                            <p>
                              a description of the copyrighted work or other
                              intellectual property right that you claim has
                              been infringed;
                            </p>
                          </li>
                          <li>
                            <p>
                              a description of the material that you claim is
                              infringing and where it is located on the Service;
                            </p>
                          </li>
                          <li>
                            <p>
                              11.3.4. your address, telephone number, and email
                              address;
                            </p>
                          </li>
                          <li>
                            <p>
                              a statement by you that you have a good faith
                              belief that the use of the materials on the
                              Service of which you are complaining is not
                              authorized by the copyright or other intellectual
                              property right owner, its agent, or the law; and
                            </p>
                          </li>
                          <li>
                            <p>
                              a statement by you that the above information in
                              your notice is accurate and that, under penalty of
                              perjury, you are the copyright or other
                              intellectual property right owner or authorized to
                              act on the copyright or intellectual property
                              owner’s behalf. Your Notification of Claimed
                              Infringement may be shared by Brandclub with the
                              user alleged to have infringed a right you own or
                              control as well as with the operators of publicly
                              available databases that track notifications of
                              claimed infringement, and you consent to Brandclub
                              making such disclosures. You should consult with
                              your own lawyer or see 17 U.S.C. § 512 to confirm
                              your obligations to provide a valid notice of
                              claimed infringement.
                            </p>
                          </li>
                        </ol>
                      </li>
                      <li>
                        <p>
                          <strong>Repeat Infringers</strong>. Brandclub’s policy
                          is to: (a) remove or disable access to material that
                          Brandclub believes in good faith, upon notice from an
                          intellectual property rights owner or authorized
                          agent, is infringing the intellectual property rights
                          of a third party by being made available through the
                          Service; and (b) in appropriate circumstances, to
                          terminate the accounts of and block access to the
                          Service by any user who repeatedly or egregiously
                          infringes other people’s copyright or other
                          intellectual property rights. Brandclub will terminate
                          the accounts of Users that are determined by Brandclub
                          to be repeat infringers. Brandclub reserves the right,
                          however, to suspend or terminate accounts of any User,
                          in our sole discretion, if we believe you have
                          violated these Terms or jeopardize the integrity of
                          the Service.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Counter Notification</strong>. If you receive
                          a notification from Brandclub that material made
                          available by you on or through the Service has been
                          the subject of a Notification of Claimed Infringement,
                          then you will have the right to provide Brandclub with
                          what is called a “Counter Notification.” To be
                          effective, a Counter Notification must be in writing,
                          provided to Brandclub’s Designated Agent through one
                          of the methods identified in Section 11.2, and include
                          substantially the following information:
                        </p>
                        <ol>
                          <li>
                            <p>your physical or electronic signature;</p>
                          </li>
                          <li>
                            <p>
                              identification of the material that has been
                              removed or to which access has been disabled and
                              the location at which the material appeared before
                              it was removed or access to it was disabled;
                            </p>
                          </li>
                          <li>
                            <p>
                              a statement under penalty of perjury that you have
                              a good faith belief that the material was removed
                              or disabled as a result of mistake or
                              misidentification of the material to be removed or
                              disabled; and
                            </p>
                          </li>
                          <li>
                            <p>
                              your name, address, and telephone number, and a
                              statement that you consent to the jurisdiction of
                              Federal District Court for the judicial district
                              in which the address is located, or if you are
                              residing outside of the United States, then for
                              any judicial district in which Brandclub may be
                              found, and that you will accept service of process
                              from the person who provided notification under
                              Section 11.2 above or an agent of that person. A
                              party submitting a Counter Notification should
                              consult a lawyer or see 17 U.S.C. § 512 to confirm
                              the party’s obligations to provide a valid counter
                              notification under the Copyright Act.
                            </p>
                          </li>
                        </ol>
                      </li>
                      <li>
                        <p>
                          <strong>
                            Reposting of Content Subject to a Counter
                            Notification
                          </strong>
                          . If you submit a Counter Notification to Brandclub in
                          response to a Notification of Claimed Infringement,
                          then Brandclub will promptly provide the person who
                          provided the Notification of Claimed Infringement with
                          a copy of your Counter Notification and inform that
                          person that Brandclub will replace the removed User
                          Content or cease disabling access to it in 10 business
                          days, and Brandclub will replace the removed User
                          Content and cease disabling access to it not less than
                          10, nor more than 14, business days following receipt
                          of the Counter Notification, unless Brandclub’s
                          Designated Agent receives notice from the party that
                          submitted the Notification of Claimed Infringement
                          that such person has filed an action seeking a court
                          order to restrain the user from engaging in infringing
                          activity relating to the material on Brandclub’s
                          system or network.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>
                            False Notifications of Claimed Infringement of
                            Counter Notification
                          </strong>
                          . The Copyright Act provides at 17 U.S.C. § 512(f)
                          that: “[a]ny person who knowingly materially
                          misrepresents under [Section 512 of the Copyright Act
                          (17 U.S.C. § 512)] (1) that material or activity is
                          infringing, or (2) that material or activity was
                          removed or disabled by mistake or misidentification,
                          will be liable for any damages, including costs and
                          attorneys’ fees, incurred by the alleged infringer, by
                          any copyright owner or copyright owner’s authorized
                          licensee, or by a service provider, who is injured by
                          such misrepresentation, as the result of Brandclub
                          relying upon such misrepresentation in removing or
                          disabling access to the material or activity claimed
                          to be infringing, or in replacing the removed material
                          or ceasing to disable access to it.” Brandclub
                          reserves the right to seek damages from any party that
                          submits a Notification of Claimed Infringement or
                          Counter Notification in violation of the law.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 12 */}
                  <li>
                    <p>
                      <strong>12. Modification of these terms</strong>. We may,
                      from time to time, change these Terms. Please check these
                      Terms periodically for changes. Revisions will be
                      effective immediately except that, for existing users,
                      material revisions will be effective 30 days after posting
                      or notice to you of the revisions unless otherwise stated.
                      We may require that you accept the modified Terms in order
                      to continue to use the Service. If you do not agree to the
                      modified terms, then you should [remove your User Content
                      and] discontinue your use of the Service. Except as
                      expressly permitted in this Section 12, these Terms may be
                      amended only by a written agreement signed by authorized
                      representatives of the parties to these Terms.
                    </p>
                  </li>
                  {/* 13 */}
                  <li>
                    <p>
                      <strong>
                        Term, termination, and modification of the Service
                      </strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          <strong>Term</strong>. These Terms are effective
                          beginning when you accept the Terms or first download,
                          install, access, or use the Service, and ending when
                          terminated as described in Section 13.2.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Termination</strong>. If you violate any
                          provision of these Terms, your authorization to access
                          the Service automatically terminate. In addition,
                          Brandclub may, at its sole discretion, terminate these
                          Terms or your account on the Service, or suspend or
                          terminate your access to the Service, at any time for
                          any reason or no reason, with or without notice, and
                          without any liability to you arising from such
                          termination. You may terminate your account and these
                          Terms at any time by contacting customer service at
                          <a href={"mailto:support@brandclub.com"}>
                            support@brandclub.com
                          </a>
                          . If you voluntarily terminate your account, you will
                          lose access to all Locked Rewards.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Effect of Termination</strong>. Upon
                          termination of these Terms: (a) your license rights
                          will terminate and you must immediately cease all use
                          of the Service; (b) you will no longer be authorized
                          to access your account or the Service; and (c) you
                          will be unable to cash out any Unlocked Rewards or
                          Locked Rewards in your Service account. Sections 5.3,
                          6, 13.3, 14, 15, 16, 17 and 18 will survive. You are
                          solely responsible for retaining copies of any User
                          Content you Post to the Service since upon termination
                          of your account, you may lose access rights to any
                          User Content you Posted to the Service. If your
                          account has been terminated for a breach of these
                          Terms, then you are prohibited from creating a new
                          account on the Service using a different name, email
                          address or other forms of account verification.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Modification of the Service</strong>.
                          Brandclub reserves the right to modify or discontinue
                          all or any portion of the Service at any time
                          (including by limiting or discontinuing certain
                          features of the Service), temporarily or permanently,
                          without notice to you. Brandclub will have no
                          liability for any change to the Service, including any
                          paid-for functionalities of the Service, or any
                          suspension or termination of your access to or use of
                          the Service. You should retain copies of any User
                          Content you Post to the Service so that you have
                          permanent copies in the event the Service is modified
                          in such a way that you lose access to User Content you
                          Posted to the Service.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 14 */}
                  <li>
                    <p>
                      <strong>Indemnification</strong>. To the fullest extent
                      permitted by law, you are responsible for your use of the
                      Service, and you will defend and indemnify Brandclub and
                      its officers, directors, employees, consultants,
                      affiliates, subsidiaries and agents (together, the
                      “Indemnitees”) from and against every claim brought by a
                      third party, including by Brands or Approved Retailers,
                      and any related liability, damage, loss, and expense,
                      including reasonable attorneys’ fees and costs, arising
                      out of or related to: (a) your unauthorized use of, or
                      misuse of, the Service; (b) your violation of any portion
                      of these Terms, any representation, warranty, or agreement
                      referenced in these Terms, or any applicable law or
                      regulation; (c) your violation of any third-party right,
                      including any intellectual property right or publicity,
                      confidentiality, other property, or privacy right; or (d)
                      any dispute or issue between you and any third party. We
                      reserve the right, at our own expense, to assume the
                      exclusive defense and control of any matter otherwise
                      subject to indemnification by you (without limiting your
                      indemnification obligations with respect to that matter),
                      and in that case, you agree to cooperate with our defense
                      of those claims.
                    </p>
                  </li>
                  {/* 15 */}
                  <li>
                    <p>
                      <strong>Disclaimers; no warranties</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          THE SERVICE AND ALL MATERIALS AND CONTENT AVAILABLE
                          THROUGH THE SERVICE ARE PROVIDED “AS IS” AND ON AN “AS
                          AVAILABLE” BASIS. BRANDCLUB DISCLAIMS ALL WARRANTIES
                          OF ANY KIND, WHETHER EXPRESS OR IMPLIED, RELATING TO
                          THE SERVICE AND ALL MATERIALS AND CONTENT AVAILABLE
                          THROUGH THE SERVICE, INCLUDING: (A) ANY IMPLIED
                          WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                          PURPOSE, TITLE, QUIET ENJOYMENT, OR NON-INFRINGEMENT;
                          AND (B) ANY WARRANTY ARISING OUT OF COURSE OF DEALING,
                          USAGE, OR TRADE. BRANDCLUB DOES NOT WARRANT THAT THE
                          SERVICE OR ANY PORTION OF THE SERVICE, OR ANY
                          MATERIALS OR CONTENT OFFERED THROUGH THE SERVICE, WILL
                          BE UNINTERRUPTED, SECURE, OR FREE OF ERRORS, VIRUSES,
                          OR OTHER HARMFUL COMPONENTS, AND BRANDCLUB DOES NOT
                          WARRANT THAT ANY OF THOSE ISSUES WILL BE CORRECTED.
                        </p>
                      </li>
                      <li>
                        <p>
                          NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN,
                          OBTAINED BY YOU FROM THE SERVICE, THE PARTICIPATING
                          BRANDS, OR BRANDCLUB ENTITIES OR ANY MATERIALS OR
                          CONTENT AVAILABLE THROUGH THE SERVICE WILL CREATE ANY
                          WARRANTY REGARDING ANY OF THE BRANDCLUB ENTITIES OR
                          THE SERVICE THAT IS NOT EXPRESSLY STATED IN THESE
                          TERMS. WITHOUT LIMITING THE GENERALITY OF THIS SECTION
                          15, WE ARE NOT RESPONSIBLE FOR ANY DAMAGE THAT MAY
                          RESULT FROM (A) THE SERVICE AND YOUR DEALING WITH ANY
                          OTHER SERVICE USER; (B) YOUR ABILITY OR INABILITY TO
                          SYNC, ACCESS, OR SHARE ANY APPROVED RETAILER ACCOUNT,
                          SOCIAL MEDIA ACCOUNT, OR PAYMENT PROCESSING ACCOUNT;
                          (C) THE USE OF OR MISUSE OF YOUR APPROVED RETAILER
                          ACCOUNT INFORMATION BY ANY BRAND; (D) YOUR ABILITY OR
                          INABILITY TO REDEEM ANY REWARDS; (E) YOUR DEALINGS OR
                          COMMUNICATIONS WITH ANY THIRD PARTY, INCLUDING BRANDS
                          OR APPROVED RETAILERS; (F) YOUR ABILITY OR INABILITY
                          TO PURCHASE PRODUCTS PROMOTED ON BRANDCLUB; OR (G) ANY
                          ERRORS, OMISSIONS, OR INACCURACIES IN THE PRICING,
                          QUALITY, PRODUCT DESCRIPTIONS, OR SHIPPING OF ANY
                          PRODUCT PURCHASED FROM ANY APPROVED RETAILER OR BRAND.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>
                            THE PRODUCTS THAT YOU MAY PURCHASE THROUGH THE
                            SERVICE, REGARDLESS OF WHETHER YOU ARE ELIGIBLE TO
                            EARN A REWARD, ARE NOT SOLD OR ENDORSED BY BRANDCLUB
                            OR ITS AFFILIATES, AND WE HAVE NO RESPONSIBILITY FOR
                            THEM OR FOR ANY LOSS OR DAMAGE YOU MAY SUFFER FROM
                            PURCHASING OR USING THEM. YOU UNDERSTAND AND AGREE
                            THAT YOU USE ANY PORTION OF THE SERVICE AT YOUR OWN
                            DISCRETION AND RISK, AND THAT WE ARE NOT RESPONSIBLE
                            FOR ANY DAMAGE TO YOUR PROPERTY (INCLUDING YOUR
                            COMPUTER SYSTEM OR MOBILE DEVICE USED IN CONNECTION
                            WITH THE SERVICE) OR ANY LOSS OF DATA, INCLUDING
                            USER CONTENT
                          </strong>
                          . THE LIMITATIONS, EXCLUSIONS AND DISCLAIMERS IN THIS
                          SECTION APPLY TO THE FULLEST EXTENT PERMITTED BY LAW.
                          Brandclub does not disclaim any warranty or other
                          right that Brandclub is prohibited from disclaiming
                          under applicable law.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 16 */}
                  <li>
                    <p>
                      <strong>Limitation of Liability</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT
                          WILL BRANDCLUB OR ITS AFFILIATES BE LIABLE TO YOU FOR
                          ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR
                          PUNITIVE DAMAGES (INCLUDING DAMAGES FOR LOSS OF
                          PROFITS, GOODWILL, OR ANY OTHER INTANGIBLE LOSS)
                          ARISING OUT OF OR RELATING TO YOUR ACCESS TO OR USE
                          OF, OR YOUR INABILITY TO ACCESS OR USE, THE SERVICE OR
                          ANY MATERIALS OR CONTENT ON THE SERVICE, WHETHER BASED
                          ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE),
                          STATUTE, OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT
                          ANY BRANDCLUB ENTITY HAS BEEN INFORMED OF THE
                          POSSIBILITY OF DAMAGE.
                        </p>
                      </li>
                      <li>
                        <p>
                          EXCEPT AS PROVIDED IN SECTION 17.5 AND TO THE FULLEST
                          EXTENT PERMITTED BY LAW, THE AGGREGATE LIABILITY OF
                          THE BRANDCLUB ENTITIES TO YOU FOR ALL CLAIMS ARISING
                          OUT OF OR RELATING TO THE USE OF OR ANY INABILITY TO
                          USE ANY PORTION OF THE SERVICE OR OTHERWISE UNDER
                          THESE TERMS, WHETHER IN CONTRACT, TORT, OR OTHERWISE,
                          IS LIMITED TO THE GREATER OF: (A) THE AMOUNT YOU HAVE
                          PAID TO BRANDCLUB FOR ACCESS TO AND USE OF THE SERVICE
                          IN THE 12 MONTHS PRIOR TO THE EVENT OR CIRCUMSTANCE
                          GIVING RISE TO CLAIM; OR (B) $100.
                        </p>
                      </li>
                      <li>
                        <p>
                          EACH PROVISION OF THESE TERMS THAT PROVIDES FOR A
                          LIMITATION OF LIABILITY, DISCLAIMER OF WARRANTIES, OR
                          EXCLUSION OF DAMAGES IS INTENDED TO AND DOES ALLOCATE
                          THE RISKS BETWEEN THE PARTIES UNDER THESE TERMS. THIS
                          ALLOCATION IS AN ESSENTIAL ELEMENT OF THE BASIS OF THE
                          BARGAIN BETWEEN THE PARTIES. EACH OF THESE PROVISIONS
                          IS SEVERABLE AND INDEPENDENT OF ALL OTHER PROVISIONS
                          OF THESE TERMS. THE LIMITATIONS IN THIS SECTION 16
                          WILL APPLY EVEN IF ANY LIMITED REMEDY FAILS OF ITS
                          ESSENTIAL PURPOSE.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 17 */}
                  <li>
                    <p>
                      <strong>Dispute Resolution and Arbitration</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          <strong>Generally</strong>. In the interest of
                          resolving disputes between you and Brandclub in the
                          most expedient and cost-effective manner, and except
                          as described in Section 17.2 and 17.3, you and
                          Brandclub agree that every dispute arising in
                          connection with these Terms, the Service, and
                          communications from us will be resolved by binding
                          arbitration. Arbitration is less formal than a lawsuit
                          in court. Arbitration uses a neutral arbitrator
                          instead of a judge or jury, may allow for more limited
                          discovery than in court, and can be subject to very
                          limited review by courts. Arbitrators can award the
                          same damages and relief that a court can award. This
                          agreement to arbitrate disputes includes all claims
                          arising out of or relating to any aspect of these
                          Terms, the Service, or any communications to or from
                          us, whether based in contract, tort, statute, fraud,
                          misrepresentation, or any other legal theory, and
                          regardless of whether a claim arises during or after
                          the termination of these Terms. YOU UNDERSTAND AND
                          AGREE THAT, BY ENTERING INTO THESE TERMS, YOU AND
                          BRANDCLUB ARE EACH WAIVING THE RIGHT TO A TRIAL BY
                          JURY OR TO PARTICIPATE IN A CLASS ACTION.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Exceptions</strong>. Despite the provisions of
                          Section 17.1, nothing in these Terms will be deemed to
                          waive, preclude, or otherwise limit the right of
                          either party to: (a) bring an individual action in
                          small claims court; (b) pursue an enforcement action
                          through the applicable federal, state, or local agency
                          if that action is available; (c) seek injunctive
                          relief in a court of law in aid of arbitration; or (d)
                          to file suit in a court of law to address an
                          intellectual property infringement claim.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Opt-Out</strong>. If you do not wish to
                          resolve disputes by binding arbitration, you may opt
                          out of the provisions of this Section 17 within 30
                          days after the date that you agree to these Terms by
                          sending a letter to Fuelcomm Inc, Attention: Legal
                          Department – Arbitration Opt-Out, 801 5th Ave, Suite
                          2800, Seattle, WA 98104 that specifies: your full
                          legal name, the email address associated with your
                          account on the Service, and a statement that you wish
                          to opt out of arbitration (“
                          <strong>Opt-Out Notice</strong>”). Once Brandclub
                          receives your Opt-Out Notice, this Section 17 will be
                          void and any action arising out of these Terms will be
                          resolved as set forth in Section 18.7. The remaining
                          provisions of these Terms will not be affected by your
                          Opt-Out Notice.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Arbitrator</strong>. Any arbitration between
                          you and Brandclub will be settled under the Federal
                          Arbitration Act and administered by the American
                          Arbitration Association (“AAA”) under its Consumer
                          Arbitration Rules (collectively, “AAA Rules”) as
                          modified by these Terms. The AAA Rules and filing
                          forms are available online at www.adr.org, by calling
                          the AAA at 1-800-778-7879, or by contacting Brandclub.
                          The arbitrator has exclusive authority to resolve any
                          dispute relating to the interpretation, applicability,
                          or enforceability of this binding arbitration
                          agreement.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Notice of Arbitration; Process</strong>. A
                          party who intends to seek arbitration must first send
                          a written notice of the dispute to the other party by
                          certified U.S. Mail or by Federal Express (signature
                          required) or, only if that other party has not
                          provided a current physical address, then by
                          electronic mail (“Notice of Arbitration”). Brandclub’s
                          address for the Notice of Arbitration is: Fuelcomm
                          Inc., 801 5th Ave, Suite 2800, Seattle, WA 98104. The
                          Notice of Arbitration must: (a) describe the nature
                          and basis of the claim or dispute; and (b) set forth
                          the specific relief sought (“Demand”). The parties
                          will make good faith efforts to resolve the claim
                          directly, but if the parties do not reach an agreement
                          to do so within 30 days after the Notice of
                          Arbitration is received, you or Brandclub may commence
                          an arbitration proceeding. All arbitration proceedings
                          between the parties will be confidential unless
                          otherwise agreed by the parties in writing. During the
                          arbitration, the amount of any settlement offer made
                          by you or Brandclub must not be disclosed to the
                          arbitrator until after the arbitrator makes a final
                          decision and award, if any. If the arbitrator awards
                          you an amount higher than the last written settlement
                          amount offered by Brandclub in settlement of the
                          dispute prior to the award, Brandclub will pay to you
                          the higher of: (i) the amount awarded by the
                          arbitrator; or (ii) $10,000.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Fees</strong>. If you commence arbitration in
                          accordance with these Terms, Brandclub will reimburse
                          you for your payment of the filing fee, unless your
                          claim is for more than US $10,000, in which case the
                          payment of any fees will be decided by the AAA Rules.
                          Any arbitration hearing will take place at a location
                          to be agreed upon in the county and state of your
                          [residence/billing address], but if the claim is for
                          US $10,000 or less, you may choose whether the
                          arbitration will be conducted: (a) solely on the basis
                          of documents submitted to the arbitrator; (b) through
                          a non-appearance based telephone hearing; or (c) by an
                          in-person hearing as established by the AAA Rules in
                          the county (or parish) of your residence/billing
                          address. If the arbitrator finds that either the
                          substance of your claim or the relief sought in the
                          Demand is frivolous or brought for an improper purpose
                          (as measured by the standards set forth in Federal
                          Rule of Civil Procedure 11(b)), then the payment of
                          all fees will be governed by the AAA Rules. In that
                          case, you agree to reimburse Brandclub for all monies
                          previously disbursed by it that are otherwise your
                          obligation to pay under the AAA Rules. Regardless of
                          the manner in which the arbitration is conducted, the
                          arbitrator must issue a reasoned written decision
                          sufficient to explain the essential findings and
                          conclusions on which the decision and award, if any,
                          are based. The arbitrator may make rulings and resolve
                          disputes as to the payment and reimbursement of fees
                          or expenses at any time during the proceeding and upon
                          request from either party made within 14 days of the
                          arbitrator’s ruling on the merits.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>No Class Actions</strong>. YOU AND BRANDCLUB
                          AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER
                          ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A
                          PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR
                          REPRESENTATIVE PROCEEDING. Further, unless both you
                          and Brandclub agree otherwise, the arbitrator may not
                          consolidate more than one person’s claims and may not
                          otherwise preside over any form of a representative or
                          class proceeding.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Modifications</strong> to this Arbitration
                          Provision. If Brandclub makes any future change to
                          this arbitration provision, other than a change to
                          Brandclub’s address for Notice of Arbitration, you may
                          reject the change by sending us written notice within
                          30 days of the change to Brandclub’s address for
                          Notice of Arbitration, in which case your account with
                          Brandclub will be immediately terminated and this
                          arbitration provision, as in effect immediately prior
                          to the changes you rejected will survive.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Enforceability</strong>. If Section 17.7 or
                          the entirety of this Section 17 is found to be
                          unenforceable, or if Brandclub receives an Opt-Out
                          Notice from you, then the entirety of this Section 17
                          will be null and void and, in that case, exclusive
                          jurisdiction and venue described in Section 18.7 will
                          govern any action arising out of or related to these
                          Terms.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 18 */}
                  <li>
                    <p>
                      <strong>Additional Provisions</strong>
                    </p>
                    <ol>
                      <li>
                        <p>
                          <strong>Modification</strong> to the Service. We may
                          change, remove, or discontinue any part of the Service
                          at any time.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Entire Agreement</strong>. These Terms,
                          together with the Privacy Policy and any other
                          agreements expressly incorporated by reference into
                          these Terms, are the entire and exclusive
                          understanding and agreement between you and Brandclub
                          regarding your use of the Service.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Assignment</strong>. You may not assign or
                          transfer these Terms or your rights under these Terms,
                          in whole or in part, by operation of law or otherwise,
                          without our prior written consent. We may assign these
                          Terms, and all rights granted under these Terms,
                          including with respect to your User Content, at any
                          time without notice or consent.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>No Waiver</strong>. The failure to require
                          performance of any provision will not affect our right
                          to require performance at any other time after that,
                          nor will a waiver by us of any breach or default of
                          these Terms, or any provision of these Terms, be a
                          waiver of any subsequent breach or default or a waiver
                          of the provision itself.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Headings</strong>. Use of section headers in
                          these Terms is for convenience only and will not have
                          any impact on the interpretation of any provision.
                          Throughout these Terms the use of the word “including”
                          means “including but not limited to”.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Severability</strong>. If any part of these
                          Terms is held to be invalid or unenforceable, the
                          unenforceable part will be given effect to the
                          greatest extent possible, and the remaining parts will
                          remain in full force and effect.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Governing Law</strong>. These Terms are
                          governed by the laws of the State of Washington
                          without regard to conflict of law principles. You and
                          Brandclub submit to the personal and exclusive
                          jurisdiction of the state courts and federal courts
                          located within King County, Washington for resolution
                          of any lawsuit or court proceeding permitted under
                          these Terms. We operate the Service from our offices
                          in Washington, and we make no representation that
                          Materials included in the Service are appropriate or
                          available for use in other locations.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Privacy Policy</strong>. Please read the
                          Brandclub Privacy Policy (the “Privacy Policy”)
                          carefully for information relating to our collection,
                          use, storage, disclosure of your personal information.
                          The Brandclub Privacy Policy is incorporated by this
                          reference into, and made a part of, these Terms.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Consent to Electronic Communications</strong>.
                          By using the Service, you consent to receiving certain
                          electronic communications from us as further described
                          in our Privacy Policy. Please read our Privacy Policy
                          to learn more about our electronic communications
                          practices. You agree that any notices, agreements,
                          disclosures, or other communications that we send to
                          you electronically will satisfy any legal
                          communication requirements, including that those
                          communications be in writing.
                        </p>
                      </li>

                      <li>
                        <p>
                          <strong>Contacting Us</strong>. The Service is offered
                          by Fuelcomm Inc., located at 801 5th Ave, Suite 2800,
                          Seattle, WA 98104. You may contact us by sending
                          correspondence to that address or by emailing us at
                          <a href={"mailto:support@brandclub.com"}>
                            support@brandclub.com
                          </a>
                          .
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Notice to California Residents</strong>. If
                          you are a California resident, under California Civil
                          Code Section 1789.3, you may contact the Complaint
                          Assistance Unit of the Division of Consumer Services
                          of the California Department of Consumer Affairs in
                          writing at 1625 N. Market Blvd., Suite S-202,
                          Sacramento, California 95834, or by telephone at (800)
                          952-5210 in order to resolve a complaint regarding the
                          Service or to receive further information regarding
                          use of the Service.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>No Support</strong>. We are under no
                          obligation to provide support for the Service. In
                          instances where we may offer support, the support will
                          be subject to published policies.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>International Use</strong>. The Service is
                          intended for visitors located within the United
                          States. We make no representation that the Service is
                          appropriate or available for use outside of the United
                          States. Access to the Service from countries or
                          territories or by individuals where such access is
                          illegal is prohibited.
                        </p>
                      </li>
                    </ol>
                  </li>
                  {/* 19 */}
                  <li>
                    <p>
                      <strong>Notice regarding Apple</strong>. Notice Regarding
                      Apple. This Section 19 only applies to the extent you are
                      using our mobile application on an iOS device. You
                      acknowledge that these Terms are between you and Brandclub
                      only, not with Apple Inc. (“Apple”), and Apple is not
                      responsible for the Service or the content thereof. Apple
                      has no obligation to furnish any maintenance and support
                      services with respect to the Service. If the Service fails
                      to conform to any applicable warranty, you may notify
                      Apple and Apple will refund any applicable purchase price
                      for the mobile application to you; and, to the maximum
                      extent permitted by applicable law, Apple has no other
                      warranty obligation with respect to the Service. Apple is
                      not responsible for addressing any claims by you or any
                      third party relating to the Service or your possession
                      and/or use of the Service, including: (1) product
                      liability claims; (2) any claim that the Service fails to
                      conform to any applicable legal or regulatory requirement;
                      or (3) claims arising under consumer protection or similar
                      legislation. Apple is not responsible for the
                      investigation, defense, settlement and discharge of any
                      third-party claim that the Service and/or your possession
                      and use of the Service infringe a third party’s
                      intellectual property rights. You agree to comply with any
                      applicable third-party terms when using the Service. Apple
                      and Apple’s subsidiaries are third-party beneficiaries of
                      these Terms, and upon your acceptance of these Terms,
                      Apple will have the right (and will be deemed to have
                      accepted the right) to enforce these Terms against you as
                      a third-party beneficiary of these Terms. You hereby
                      represent and warrant that: (a) you are not located in a
                      country that is subject to a U.S. Government embargo, or
                      that has been designated by the U.S. Government as a
                      “terrorist supporting” country; and (b) you are not listed
                      on any U.S. Government list of prohibited or restricted
                      parties.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Terms = () => {
  const ref = useRef(undefined) as any;
  const disable = false;
  if (disable) {
    return <></>;
  }
  return (
    <div
      className="site"
      style={{
        height: "unset",
      }}
      ref={ref}
    >
      <Helmet>
        <title>Terms of Service</title>
        <meta
          name="description"
          content="Review the Brandclub terms of service and other helpful information."
        />
      </Helmet>
      <TermsHeader />
      <TermsContent />
    </div>
  );
};
export default Terms;
